import {
    fps, freespins,
    he,
    he_scale,
    ico_he,
    madnes_objects,
    set_inanim,
    wi,
    wi_scale
} from "../framework/src/engine/madnes/madnes_variables";
import {main_phaser} from "../framework/src/engine/madnes/MadnesApp";


import {madnes_anim_loop, madnes_anim_play, madnes_anim_stop} from "../framework/src/engine/madnes/madnes_anims";
import {
    madnes_alpha_to,
    madnes_move_to,
    madnes_rotate_to,
    madnes_scale_to
} from "../framework/src/engine/madnes/madnes_render";
import {
    madnes_set_angle,
    madnes_set_pos,
    madnes_set_pos_x,
    madnes_set_texture,
    madnes_set_img_center,
    madnes_key_exist,
    madnes_get_alpha,
    madnes_set_alpha,
    madnes_set_pos_y,
    madnes_set_scale,
    madnes_get_pos_y, madnes_get_pos_x
} from "../framework/src/engine/madnes/madnes_object";
import {madnes_audio_loop, madnes_audio_play} from "../framework/src/engine/madnes/madnes_audio";
import {set_boom_ready, wanted_vibrate} from "./wanted_core";
import {madnes_money_to_coin} from "../framework/src/engine/madnes/madnes";
import {cylinder_pos} from "./wanted_config";
import {madnes_add_bitmap_text, madnes_set_text} from "../framework/src/engine/madnes/madnes_text";
import {
    madnes_add_graphics,
    madnes_add_mask,
    madnes_graphics_begin_fill,
    madnes_graphics_draw_rectangle
} from "../framework/src/engine/madnes/madnes_draw";

export function wanted_boom_start()
{
    set_inanim(1); //inanim = 1;

    madnes_anim_loop("spark_sprite", "anim");

    madnes_set_angle("big_win_dynamite_shadow", 0);
    madnes_set_angle("big_win_dynamite_group", 0);
    madnes_rotate_to("big_win_dynamite_shadow", 45, 1, 950);
    madnes_rotate_to("big_win_dynamite_group", 45, 1, 950);

    madnes_set_pos("big_win_dynamite_shadow", wi / 2, he * 1.4);
    madnes_move_to("big_win_dynamite_shadow", wi * 0.5, he * 0.5, 950);

    madnes_set_pos("big_win_dynamite_group", wi / 2, he * 1.4);
    madnes_move_to("big_win_dynamite_group", wi * 0.5, he * 0.38, 650, function ()
        {
            madnes_move_to("big_win_dynamite_group", wi * 0.5, he * 0.5, 300,

                function() {

                    setTimeout(function()
                    {
                        madnes_anim_stop("spark_sprite");
                        madnes_set_pos("big_win_dynamite_shadow", -9999, -9999);
                        madnes_set_pos("big_win_dynamite_group", -9999, -9999);
                    }, 100);

                    madnes_audio_play('BIG_WIN');

                    madnes_anim_play("big-win_Start", "boom_end");
                    madnes_set_pos_x("big-win_Start", 0);
                    madnes_anim_play("big-win_Start", "boom");
                    wanted_vibrate([50, 10, 100, 10, 800]);

                    wanted_snake_desk_step = 0;
                    wanted_snake_desk_pos = 0;
                    wanted_snake_desk_dir = 1;

                    if(
                        freespins.isInFreeSpins()
                    )
                    {
                        madnes_set_texture("big-win_Text-1", "freespin_win_text");
                    }
                    else
                    {
                        madnes_set_texture("big-win_Text-1", "big-win_Text-1");
                    }

                    madnes_set_img_center("big-win_Money", 0.5, 0.5);
                    madnes_set_img_center("big-win_Paper", 0.5, 0.5);
                    madnes_set_img_center("big-win_Text-1", 0.5, 1.3);

                    madnes_set_pos("big-win_Money", wi / 2, he / 2);
                    madnes_set_pos("big-win_Paper", wi / 2, he / 2);
                    madnes_set_pos("big-win_Text-1", wi / 2, he / 2);

                    madnes_scale_to("big-win_Money", 1.15, 1.15, 200,function()
                        {
                            madnes_scale_to("big-win_Money", 1, 1, 400);
                        }
                    );
                    madnes_scale_to("big-win_Paper", 1.15, 1.15, 200,function()
                        {
                            madnes_scale_to("big-win_Paper", 1, 1, 400);
                        }
                    );
                    madnes_scale_to("big-win_Text-1", 1.15, 1.15, 200,function()
                        {
                            madnes_scale_to("big-win_Text-1", 1, 1, 400);
                        }
                    );
                    if(madnes_key_exist("boom_num"))
                    {
                        madnes_scale_to("boom_num", 1.15, 1.15, 200,function()
                            {
                                madnes_scale_to("boom_num", 1, 1, 400);
                            }
                        );
                    }

                    wanted_dollars_start();
                    wanted_shake_desk();
                }
            );
        }
    );


}

export function wanted_boom_done()
{
    madnes_anim_play("big-win_Start", "boom_end");
    /*
    madnes_set_pos("big-win_Money", 370, 100);
    madnes_set_pos("big-win_Paper", 360, 180);
    madnes_set_pos("big-win_Text-1", 490, 240);
    */
    madnes_set_img_center("big-win_Money", 0.5, 0.5);
    madnes_set_img_center("big-win_Paper", 0.5, 0.5);
    madnes_set_img_center("big-win_Text-1", 0.5, 1.3);

    madnes_set_pos("big-win_Money", wi / 2, he / 2);
    madnes_set_pos("big-win_Paper", wi / 2, he / 2);
    madnes_set_pos("big-win_Text-1", wi / 2, he / 2);

    if(!madnes_key_exist("boom_num"))
    {
        madnes_add_bitmap_text("boom_num", "font1-bonus-Wanted", wi / 2, he / 2, "0", 50);
        madnes_set_img_center("boom_num", 0.5, -0.6);
    }
    else
    {
        madnes_set_text("boom_num", "0");
        madnes_set_pos("boom_num", wi / 2, he / 2);
    }

    set_boom_ready(1); // boom_ready = 1;
    madnes_audio_loop('remittance_A');
}

var wanted_dollars_enabled = false;
function wanted_dollars_start()
{
    if(wanted_dollars_enabled == false)
    {
        wanted_dollars_enabled = true;
        for(var i = 0; i < 40; i++)
        {
            (function(i) {
                setTimeout(function()
                {
                    wanted_dollars_control(i);

                }, Math.random() * 1800 + 600);
            } (i));
        }
    }
}

function wanted_dollars_end()
{
    wanted_dollars_enabled = false;
}

function wanted_dollars_control(i)
{
    if(wanted_dollars_enabled == true)
    {
        var end_x = Math.random() * ( wi * 2 ) - ( wi / 2);
        var end_y = Math.random() * ( he * 2 ) - ( he / 2);
        var total_time =  Math.random() * 1800 + 600;
        madnes_set_alpha("dollars_particle_" + i, 1);
        madnes_set_scale("dollars_particle_" + i, 1.0, 1.0);
        madnes_set_angle("dollars_particle_" + i, Math.random() * 360);
        madnes_set_pos("dollars_particle_" + i, wi / 2, he / 2);

        (function(i) {

            madnes_move_to("dollars_particle_" + i, end_x, end_y, total_time, function() {
                wanted_dollars_control(i)
            });

        } (i));

        var dir = Math.random() * 200;
        if(dir > 100)
        {
            dir = 1;
        }
        else
        {
            dir = -1;
        }
        madnes_rotate_to("dollars_particle_" + i, 360 * Math.random(), dir, total_time);

        setTimeout(madnes_alpha_to.bind(null, "dollars_particle_" + i, 0, total_time * 0.25), total_time * 0.70);
    }
}

export var wanted_snake_desk_step = 0; // Krok treseni
export function set_wanted_snake_desk_step(val) {
    wanted_snake_desk_step = val;
}


var wanted_snake_desk_pos = 0; // Pozice tresu obrazovky
export function set_wanted_snake_desk_pos(val) {
    wanted_snake_desk_pos = val;
}

var wanted_snake_desk_dir = 0; // Smer treseni
export function set_wanted_snake_desk_dir(val) {
    wanted_snake_desk_dir = val;
}


export function wanted_shake_desk()
{

    if(!madnes_key_exist("world"))
    {
        madnes_objects['world'] = main_phaser.world;

        madnes_add_graphics("world_mask", 0, 0);
        madnes_add_mask("world", "world_mask");
        madnes_graphics_begin_fill("world_mask", 0xffffff);
        madnes_graphics_draw_rectangle("world_mask", 0, 0, wi, he);
    }

    main_phaser.world.pivot.x = wi/2 * wi_scale;
    main_phaser.world.pivot.y = he/2 * he_scale;
    main_phaser.world.setBounds(-wi/2 * wi_scale, -he/2 * he_scale, wi * wi_scale, he * he_scale);

    madnes_set_angle("world", 0);
    madnes_rotate_to("world", 4, -1, ( 1000 / fps ) * 1.5, function()
    {
        madnes_rotate_to("world", 8, 1, ( 1000 / fps ) * 3, function()
        {
            madnes_rotate_to("world", 8, -1, ( 1000 / fps ) * 3, function()
            {
                madnes_rotate_to("world", 8, 1, ( 1000 / fps ) * 3, function()
                {
                    madnes_rotate_to("world", 4, -1, ( 1000 / fps ) * 1.5, function()
                    {
                        madnes_set_angle("world", 0);
                        main_phaser.world.setBounds(0, 0, wi * wi_scale, he * he_scale);
                        main_phaser.world.pivot.x = 0;
                        main_phaser.world.pivot.y = 0;
                    });
                });
            });
        });
    });

    return;

    var mult = 1 * (60/fps);
    var max = 3.0 - (wanted_snake_desk_step * 0.1);

    if(wanted_snake_desk_step >= 2)
    {
        wanted_snake_desk_pos = wanted_snake_desk_pos*1+wanted_snake_desk_dir*1*mult;
        while(wanted_snake_desk_pos < 0)
        {
            wanted_snake_desk_pos += 360;
        }
        while(wanted_snake_desk_pos >= 360)
        {
            wanted_snake_desk_pos -= 360;
        }


        madnes_set_angle("big-win_Money", wanted_snake_desk_pos);
        madnes_set_angle("big-win_Paper", wanted_snake_desk_pos);
        madnes_set_angle("big-win_Text-1", wanted_snake_desk_pos);
        if(madnes_key_exist("boom_num"))
        {
            madnes_set_angle("boom_num", wanted_snake_desk_pos);
        }

        if(wanted_snake_desk_pos == 0)
        {

            return;
        }
    }
    else if(
        wanted_snake_desk_step % 2 == 0
    )
    {
        wanted_snake_desk_pos = wanted_snake_desk_pos*1+wanted_snake_desk_dir*1*mult;
        while(wanted_snake_desk_pos < 0)
        {
            wanted_snake_desk_pos += 360;
        }
        while(wanted_snake_desk_pos >= 360)
        {
            wanted_snake_desk_pos -= 360;
        }

        madnes_set_angle("big-win_Money", wanted_snake_desk_pos);
        madnes_set_angle("big-win_Paper", wanted_snake_desk_pos);
        madnes_set_angle("big-win_Text-1", wanted_snake_desk_pos);
        if(madnes_key_exist("boom_num"))
        {
            madnes_set_angle("boom_num", wanted_snake_desk_pos);
        }

        if(wanted_snake_desk_pos > max && wanted_snake_desk_pos < 300)
        {
            wanted_snake_desk_step++;
            wanted_snake_desk_dir = -1;
        }
    }
    else if(
        wanted_snake_desk_step % 2 == 1
    )
    {
        wanted_snake_desk_pos = wanted_snake_desk_pos*1+wanted_snake_desk_dir*1*mult;

        while(wanted_snake_desk_pos < 0)
        {
            wanted_snake_desk_pos += 360;
        }
        while(wanted_snake_desk_pos >= 360)
        {
            wanted_snake_desk_pos -= 360;
        }

        madnes_set_angle("big-win_Money", wanted_snake_desk_pos);
        madnes_set_angle("big-win_Paper", wanted_snake_desk_pos);
        madnes_set_angle("big-win_Text-1", wanted_snake_desk_pos);
        if(madnes_key_exist("boom_num"))
        {
            madnes_set_angle("boom_num", wanted_snake_desk_pos);
        }

        if(wanted_snake_desk_pos > 300 && wanted_snake_desk_pos < (360-max*1))
        {
            wanted_snake_desk_step++;
            wanted_snake_desk_dir = 1;
        }
    }

    setTimeout(wanted_shake_desk, 1000 / fps);

}

export function wanted_boom_end()
{
    set_inanim(0); //inanim = 0;
    wanted_dollars_end();
    madnes_set_pos_x("big-win_Start", -9999);
    madnes_set_pos_x("big-win_Money", -9999);
    madnes_set_pos_x("big-win_Paper", -9999);
    madnes_set_pos_x("big-win_Text-1", -9999);
    madnes_set_pos_x("x2", -9999);
    if(madnes_key_exist("boom_num"))
    {
        madnes_set_pos("boom_num", wi / 2 + 100, -9999);
    }
}
// Animace vybuchu a treseni obrazu konec




// zobrazeni vyhernich linii
function wanted_show_lines()
{
    for(var i = 1; i <= 10; i++)
    {
        wanted_show_line(i);
    }
}

export function wanted_hide_lines()
{
    for(var i = 1; i <= 10; i++)
    {
        wanted_hide_line(i);
    }
}

var line_states = new Array();
export function wanted_show_line(line)
{
    line_states[line] = 1;

    var tmp_off = 22;

    madnes_set_pos("lines_" + line + "_line", 55, tmp_off);
    madnes_set_pos_x("lines_" + line + "_l", 0);
    madnes_set_pos_x("lines_" + line + "_r", 1224);

    switch(line)
    {
        case 1:
        case "1":
            madnes_set_pos_y("lines_" + line + "_l", 292 + tmp_off);
            madnes_set_pos_y("lines_" + line + "_r", 293 + tmp_off);
            break;
        case 2:
        case "2":
            madnes_set_pos_y("lines_" + line + "_l", 90 + tmp_off);
            madnes_set_pos_y("lines_" + line + "_r", 117 + tmp_off);

            break;
        case 3:
        case "3":
            madnes_set_pos_y("lines_" + line + "_l", 466 + tmp_off);
            madnes_set_pos_y("lines_" + line + "_r", 490 + tmp_off);
            break;
        case 4:
        case "4":
            madnes_set_pos_y("lines_" + line + "_l", 519 + tmp_off);
            madnes_set_pos_y("lines_" + line + "_r", 542 + tmp_off);
            break;
        case 5:
        case "5":
            madnes_set_pos_y("lines_" + line + "_l", 2 + tmp_off);
            madnes_set_pos_y("lines_" + line + "_r", 64 + tmp_off);
            break;
        case 6:
        case "6":
            madnes_set_pos_y("lines_" + line + "_l", 241 + tmp_off);
            madnes_set_pos_y("lines_" + line + "_r", 241 + tmp_off);
            break;
        case 7:
        case "7":
            madnes_set_pos_y("lines_" + line + "_l", 343 + tmp_off);
            madnes_set_pos_y("lines_" + line + "_r", 346 + tmp_off);
            break;
        case 8:
        case "8":
            madnes_set_pos_y("lines_" + line + "_l", 415 + tmp_off);
            madnes_set_pos_y("lines_" + line + "_r", 170 + tmp_off);
            break;
        case 9:
        case "9":
            madnes_set_pos_y("lines_" + line + "_l", 143 + tmp_off);
            madnes_set_pos_y("lines_" + line + "_r", 440 + tmp_off);
            break;
        case 10:
        case "10":
            madnes_set_pos_y("lines_" + line + "_l", 571 + tmp_off);
            madnes_set_pos_y("lines_" + line + "_r", 1 + tmp_off);
            break;
    }
}

function wanted_hide_line(line)
{
    line_states[line] = 0;
    madnes_set_pos("lines_" + line + "_line", -9999, -9999);
    madnes_set_pos("lines_" + line + "_l", -9999, -9999);
    madnes_set_pos("lines_" + line + "_r", -9999, -9999);

}
// zobrazeni vyhernich linii konec




// Freespin -> zobrazeni / skryti ohoreleho valce
var freespin_state = new Array();
export function wanted_freespin_show(x)
{
    if(freespin_state[x-1] != 1)
    {
        madnes_set_alpha("freespin_bg_" + ( x - 1 ), 0);
        madnes_alpha_to("freespin_bg_" + ( x - 1 ), 1, 500);
    }

    freespin_state[x-1] = 1;

    //madnes_set_alpha("freespin_bg_" + (x - 1), 1);
    switch(x)
    {
        case 1:
            madnes_set_pos_x("freespin_bg_" + (x - 1), 0);
            break;
        case 2:
            madnes_set_pos_x("freespin_bg_" + (x - 1), 286);
            break;
        case 3:
            madnes_set_pos_x("freespin_bg_" + (x - 1), 522);
            break;
        case 4:
            madnes_set_pos_x("freespin_bg_" + (x - 1), 758);
            break;
        case 5:
            madnes_set_pos_x("freespin_bg_" + (x - 1), 992);
            break;
    }
    /*
    if(madnes_get_alpha("freespin_bg_" + ( x - 1 )) < 1)
    {
        var a = madnes_get_alpha("freespin_bg_" + ( x - 1 )) * 1 + 0.1;
        if(a > 1)
        {
            a = 1;
        }
        madnes_set_alpha("freespin_bg_" + ( x - 1 ), a)
        setTimeout("wanted_freespin_show(" + x + ")", 1000 / fps);
    }
    else
    {
        madnes_set_alpha("freespin_bg_" + ( x - 1 ), 1);
    }
    */
}

export function wanted_freespin_hide(x)
{
    freespin_state[x-1] = 0;

    if(madnes_get_alpha("freespin_bg_" + ( x - 1 )) > 0)
    {
        madnes_alpha_to("freespin_bg_" + ( x - 1 ), 0, 500, function() {
            wanted_freespin_hide(x);
        });
    }
    else
    {
        madnes_set_alpha("freespin_bg_" + ( x - 1 ), 0);
        madnes_set_pos_x("freespin_bg_" + ( x - 1 ), -9999);
    }
}
// Freespin -> zobrazeni / skryti ohoreleho valce konec





// Obsluha animaci prustrelu symbolu
var dira_pohyb = new Array();
dira_pohyb["t0"] = 0;

export function wanted_bullet_show(x, y)
{
    var disp = 80;
    if(dira_pohyb[x] == null)
    {
        dira_pohyb[x] = new Array();
    }
    dira_pohyb[x][y] = new Array();
    dira_pohyb[x][y][0] = (Math.random() * disp) - (disp / 2);
    dira_pohyb[x][y][1] = (Math.random() * disp) * -1/* - (disp / 2)*/;

    if(dira_pohyb["t0"] == 0)
    {
        dira_pohyb["t0"] = (Math.random() * disp) - (disp / 2);
        dira_pohyb["t1"] = (Math.random() * ( disp / 2 ) )  * -1/* - (disp / 2)*/;
    }

    madnes_audio_play("WIN_SHOT_"+y);

    madnes_set_pos_y("diry_" + (x-1) + "_" + (y-1) + "_dira", ico_he * ( x - 1 ) + dira_pohyb[x][y][1] + 22);
    madnes_set_pos_y("diry_" + (x-1) + "_" + (y-1) + "_ohen", ico_he * ( x - 1 ) + dira_pohyb[x][y][1] + 22);

    madnes_set_pos_y("diry_" + (x-1) + "_" + (y-1) + "_dust", ico_he * ( x - 1 ) + dira_pohyb[x][y][1] + 22 + 80);
    madnes_set_alpha("diry_" + (x-1) + "_" + (y-1) + "_ohen", 1);
    madnes_set_alpha("diry_" + (x-1) + "_" + (y-1) + "_dust", 1);

    madnes_alpha_to("diry_" + (x-1) + "_" + (y-1) + "_ohen", 0, 1000 / fps * 20);

    switch(y)
    {
        case 1:
            madnes_set_pos_x("diry_" + (x-1) + "_" + (y-1) + "_dira", 35 + dira_pohyb[x][y][0]);
            madnes_set_pos_x("diry_" + (x-1) + "_" + (y-1) + "_ohen", 35 + dira_pohyb[x][y][0]);
            break;
        case 2:
            madnes_set_pos_x("diry_" + (x-1) + "_" + (y-1) + "_dira", 270 + dira_pohyb[x][y][0]);
            madnes_set_pos_x("diry_" + (x-1) + "_" + (y-1) + "_ohen", 270 + dira_pohyb[x][y][0]);
            break;
        case 3:
            madnes_set_pos_x("diry_" + (x-1) + "_" + (y-1) + "_dira", 520 + dira_pohyb[x][y][0]);
            madnes_set_pos_x("diry_" + (x-1) + "_" + (y-1) + "_ohen", 520 + dira_pohyb[x][y][0]);
            break;
        case 4:
            madnes_set_pos_x("diry_" + (x-1) + "_" + (y-1) + "_dira", 740 + dira_pohyb[x][y][0]);
            madnes_set_pos_x("diry_" + (x-1) + "_" + (y-1) + "_ohen", 740 + dira_pohyb[x][y][0]);
            break;
        case 5:
            madnes_set_pos_x("diry_" + (x-1) + "_" + (y-1) + "_dira", 980 + dira_pohyb[x][y][0]);
            madnes_set_pos_x("diry_" + (x-1) + "_" + (y-1) + "_ohen", 980 + dira_pohyb[x][y][0]);
            break
    }
    setTimeout(wanted_bullet_show2.bind(null, x, y), 30);
}

function wanted_bullet_show2(x, y)
{
    switch(y)
    {
        case 1:
            madnes_set_pos_x("diry_" + (x-1) + "_" + (y-1) + "_dust", 100 + 55 + dira_pohyb[x][y][0]);
            break;
        case 2:
            madnes_set_pos_x("diry_" + (x-1) + "_" + (y-1) + "_dust", 100 + 290 + dira_pohyb[x][y][0]);
            break;
        case 3:
            madnes_set_pos_x("diry_" + (x-1) + "_" + (y-1) + "_dust", 100 + 540 + dira_pohyb[x][y][0]);
            break;
        case 4:
            madnes_set_pos_x("diry_" + (x-1) + "_" + (y-1) + "_dust", 100 + 760 + dira_pohyb[x][y][0]);
            break;
        case 5:
            madnes_set_pos_x("diry_" + (x-1) + "_" + (y-1) + "_dust", 100 + 1000 + dira_pohyb[x][y][0]);
            break
    }

    //setTimeout("wanted_bullet_show3("+x+","+y+",0)", 30);

    var time_fps = 16;
    var time_fps_dif = 0.3;

    madnes_move_to(
        "diry_" + (x-1) + "_" + (y-1) + "_dust",
        madnes_get_pos_x("diry_" + (x-1) + "_" + (y-1) + "_dust") + dira_pohyb["t0"],
        madnes_get_pos_y("diry_" + (x-1) + "_" + (y-1) + "_dust") + dira_pohyb["t1"],
        ( 1000 / fps ) * time_fps,
        function(x, y)
        {
            madnes_set_pos_x("diry_" + (x-1) + "_" + (y-1) + "_dust", -9999);
            dira_pohyb["t0"] = 0;
        }.bind(this, x, y)
    );
    setTimeout(
        madnes_alpha_to.bind(this ,"diry_" + (x-1) + "_" + (y-1) + "_dust", 0, ( 1000 / fps ) * ( time_fps * ( 1 - time_fps_dif ) ) ),
        ( 1000 / fps ) * ( time_fps * time_fps_dif )
    );
}
/*
function wanted_bullet_show3(x,y,num)
{
	madnes_set_pos_x("diry_" + (x-1) + "_" + (y-1) + "_ohen", -9999);
	if(num < 4)
	{
		madnes_set_pos_x("diry_" + (x-1) + "_" + (y-1) + "_dust", madnes_get_pos_x("diry_" + (x-1) + "_" + (y-1) + "_dust") * 1 - 5 + dira_pohyb[x][y][0]);
		setTimeout("wanted_bullet_show3("+x+","+y+","+(num+1)+")", 30);
	}
	else
	{
		madnes_set_pos_x("diry_" + (x-1) + "_" + (y-1) + "_dust", -9999);
	}
}
*/
export function wanted_bullets_hide()
{
    for(var j = 1; j <= 3; j++)
    {
        for(var i = 1; i <= 5; i++)
        {
            wanted_bullet_hide(j, i);
        }
    }
}

function wanted_bullet_hide(x, y)
{
    madnes_set_pos_x("diry_" + ( x - 1 ) + "_" + ( y - 1 ) + "_dira", -9999);
    madnes_set_pos_x("diry_" + ( x - 1 ) + "_" + ( y - 1 ) + "_ohen", -9999);
    madnes_set_pos_x("diry_" + ( x - 1 ) + "_" + ( y - 1 ) + "_dust", -9999);
}
// Obsluha animaci prustrelu symbolu konec



// animace symbolu scatter pri dopadu
export function wanted_scatter_scale_anim(i, j, step)
{
    if(step < 10)
    {
        madnes_set_pos_x("reels_bufer_" + i + "_" + j, madnes_get_pos_x("reels_bufer_" + i + "_" + j) * 1 + 1);
        madnes_set_pos_y("reels_bufer_" + i + "_" + j, madnes_get_pos_y("reels_bufer_" + i + "_" + j) * 1 + 1);
        madnes_set_scale("reels_bufer_" + i + "_" + j, 1 - ( 0.01 * step ), 1 - ( 0.01 * step ));

        step += 60 / fps;
        setTimeout(wanted_scatter_scale_anim.bind(null, i, j, step), 1000 / fps);
    }
    else if(step < 20)
    {
        madnes_set_pos_x("reels_bufer_" + i + "_" + j, madnes_get_pos_x("reels_bufer_" + i + "_" + j) * 1 - 1);
        madnes_set_pos_y("reels_bufer_" + i + "_" + j, madnes_get_pos_y("reels_bufer_" + i + "_" + j) * 1 - 1);
        madnes_set_scale("reels_bufer_" + i + "_" + j, 1 - ( 0.01 * ( 20 - step ) ), 1 - ( 0.01 * ( 20 - step) ));

        step += 60 / fps;
        setTimeout(wanted_scatter_scale_anim.bind(null, i, j, step), 1000 / fps);
    }
}

// animace cislis pri vyhre

var win_sum_buffer_pos = 0;
export var wanted_show_win_sum_animated = 0;

export function set_wanted_show_win_sum_animated(val) {
    wanted_show_win_sum_animated = val;
}

export function wanted_show_win_sum_start(win_set)
{
    if(typeof win_set.multiplier == "undefined")
    {
        win_set.multiplier = 1;
    }

    wanted_show_win_sum_animated = 1;

    //var money = ( win_set.win * win_set.multiplier ).toString();
    var money = ( madnes_money_to_coin( win_set.win ) * 1 ).toString();
    var digits = money.toString().length;
    var line = win_set.line*1+1*1;
    var count = win_set.position.length;

    var center = cylinder_pos[2];
    if(count <= 3)
    {
        center = cylinder_pos[1];
    }

    center = center * 1 + 100;

    var top = 0;
    if(count <= 3)
    {
        switch(line)
        {
            case 2: case "2":
            case 6: case "6":
            case 9: case "9":
            top = 65;
            break;
            case 1: case "1":
            case 4: case "4":
            case 5: case "5":
            case 10: case "10":
            top = 256;
            break;
            case 3: case "3":
            case 7: case "7":
            case 8: case "8":
            top = 460;
            break;

        }
    }
    else
    {
        switch(line)
        {
            case 2: case "2":
            case 4: case "4":
            case 6: case "6":
            top = 65;
            break;
            case 1: case "1":
            case 8: case "8":
            case 9: case "9":
            case 10: case "10":
            top = 256;
            break;
            case 3: case "3":
            case 5: case "5":
            case 7: case "7":
            top = 460;
            break;
        }
    }

    var cur_pos = win_sum_buffer_pos;
    win_sum_buffer_pos = win_sum_buffer_pos * 1 + 1;


    if(!madnes_key_exist("win_sum_groups"))
    {
        madnes_add_bitmap_text("win_sum_groups", "font2-bonus-Wanted", wi / 2, he / 2, money.toString(), 100);
        madnes_set_img_center("win_sum_groups", 0.5, 0);
    }
    else
    {
        madnes_set_text("win_sum_groups", money.toString());
    }

    madnes_set_pos("win_sum_groups", center, top);

    madnes_set_alpha("win_sum_groups", 0);
    madnes_alpha_to("win_sum_groups", 1, 300, function()
    {
        setTimeout(function()
        {
            madnes_alpha_to("win_sum_groups", 0, 100, function()
            {
                wanted_show_win_sum_animated = 0;
                madnes_set_pos_x("win_sum_groups", -9999);
            });
        }, 500);
    });
}

